export const colors = {
    black: '#2C2C2C',
    grey: '#696969',
    background: '#F6F7F8',
    primary: '#8AB6A0',
    secondary: '#D9E4DD',
    accent: '#4A6D7C',
    error: '#D96C63',
};
